import { Pipe, PipeTransform } from '@angular/core';
import { beautifyCamelCaseString } from 'src/app/common/stringUtils';

@Pipe({
  name: 'displayCamelCaseString',
  standalone: true,
})
export class DisplayCamelCaseStringPipe implements PipeTransform {
  /**
   * A pipe to beautify displayed camelCase strings in UI
   * For single words it capitalizes first letter: resource -> Resource
   * For concatenated words with "_": resourceCategory -> Resource Category
   */

  public transform(value?: string): string {
    if (!value) {
      return '';
    }

    return beautifyCamelCaseString(value);
  }
}
